"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M5 4v2h14V4zm0 10h4v6h6v-6h4l-7-7z"
}), 'PublishSharp');